/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from "lodash";
import Modal from 'react-responsive-modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import CountUp from 'react-countup';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import Select from 'react-select';
import { getDDMMYYYY, getDDMMYYYYHHMMSS, getHyphenDDMMMYYYYHHMM } from '../common/utils';
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CSVFileValidator from 'csv-file-validator';
import more from 'material-ui/svg-icons/notification/more';
import $ from 'jquery';
//import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/datepicker';
var redirectURL = require('../redirectURL');
var moment = require('moment');
var { getDeptCode, getDeptMenuPath } = require('../common/deptCode');

export default class CustomerMaster extends Component {
    state = {
        show: false,
        basicTitle: '',
        basicType: "default",
        loadshow: "show-n",
        overly: "show-n",
        rowData: [],
        pivotmodeis: false,
        pivotcols: [],
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true

        },
        frameworkComponents: {
        },
        rowModelhighchartoptionsType: 'enterprise',
        rowGroupPanelShow: 'always',
        animateRows: true,
        debug: true,
        showToolPanel: true,
        suppressAggFuncInHeader: true,
        statusBar: {
            statusPanels: [
                {
                    statusPanel: "agTotalAndFilteredRowCountComponent",
                    align: "left"
                },
                {
                    statusPanel: "agTotalRowCountComponent",
                    align: "center"
                },
                { statusPanel: "agFilteredRowCountComponent" },
                { statusPanel: "agSelectedRowCountComponent" },
                { statusPanel: "agAggregationComponent" }
            ]
        },
        sideBar: {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel"
                },
                {
                    id: "filters",
                    labelDefault: "Filters",
                    labelKey: "filters",
                    iconKey: "filter",
                    toolPanel: "agFiltersToolPanel"
                }
            ]
        },
        csvcontent: [],
        file: '',
        slider: 'show-n',
        sliderforeditcustomer: false,
        editCustomer: {},
        editCustomerOriginal: {}
    }

    componentDidMount() {
        this.loadData()
    }

    loadData = () => {
        // LCV / other dept menus only; SPD payload stays {}. See DEPT_CODE_MASTER_GUIDE.md
        var customerParams = {}
        if (getDeptCode() != '') {
            customerParams.dept_code = getDeptCode()
        }
        redirectURL.post("/masters/getCustomersMaster", customerParams,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("userid")
              }
          }).then(res => {
            let respData = res.data
            // console.log("respData",respData)
            this.setState({
                rowData: respData.plantMasters,
            })
            //  console.log("resData", respData)
        })
    }
    closeAlert = () => {
        this.setState({
            show: false,
            basicType: "",
            basicTitle: ""
        })
    }

    onGridReady = params => {
        this.gridApi = params.api;
        //console.log("Grid is: ", params);
        this.gridColumnApi = params.columnApi;
    };

    onGridState = () => {
        //console.log(this.gridApi);
        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();
        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();
        /*Get Current Pivot Columns State and Store in this.pivotColumns,
         * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();
        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
    }

    changeTptFileHandler = async (e) => {
        if(e.target.files.length !== 0){
            
   
            const config = {
                headers: [
                    {
                        name: 'consignee_code',
                        inputName: 'consignee_code',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        },
                        pattern: aplhanumeichypen
                    },
                    {
                        name: 'consignee_name',
                        inputName: 'consignee_name',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        },
                        pattern: aplhanumeichypen
                    },      
                    {
                        name: 'consignee_address',
                        inputName: 'consignee_address',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },              
                    {
                        name: 'consignee_city',
                        inputName: 'consignee_city',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },                                  
                    {
                        name: 'consignee_state',
                        inputName: 'consignee_state',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'postal_code',
                        inputName: 'postal_code',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'consignee_latitude',
                        inputName: 'consignee_latitude',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'consignee_longitude',
                        inputName: 'consignee_longitude',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'consignee_zone',
                        inputName: 'consignee_zone',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },                   
                    {
                        name: 'consignee_region',
                        inputName: 'consignee_region',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    }
                    , {
                        name: 'consignee_area_office',
                        inputName: 'consignee_area_office',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    }
                    , {
                        name: 'credit_sales',
                        inputName: 'credit_sales',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    }, {
                        name: 'destination_type',
                        inputName: 'destination_type',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'mobile_no_1',
                        inputName: 'mobile_no_1',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'mobile_no_2',
                        inputName: 'mobile_no_2',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'mobile_no_3',
                        inputName: 'mobile_no_3',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        // Dealer Mail ID - optional, same as every other field below consignee_name.
                        // Files without this column keep working exactly as before (backward
                        // compatible); format itself is validated server-side in
                        // uploadCustomerMastersData, never trusted from the client alone.
                        name: 'consignee_email',
                        inputName: 'consignee_email',
                        required: false,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    //  {
                    //     name: 'consignee_contact_no',
                    //     inputName: 'consignee_contact_no',
                    //     required: true,
                    //     requiredError: function (headerName, rowNumber, columnNumber) {
                    //         return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    //     }
                    // }
                ]
            }
            const aplhanumeichypen = new RegExp(/^[a-zA-Z0-9 -.@,#_&]*$/); // define allowed characters using regex
            // const allowedCharacters = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/; // define allowed characters using regex
            // const validNumber = new RegExp(/^-?([0-9]|[1-8][0-9]|90)(\.\d+)?$/);
            // const validDigit = new RegExp(/^[0-9.]*$/);
            // const validText = new RegExp(/^[a-zA-Z -_.&@]+$/);
            // const validAddress = new RegExp(/^[a-zA-Z0-9()-_/#@&,. :]+$/);

            var data = CSVFileValidator(e.target.files[0], config)
                .then((csvData) => {
                    // console.log('csvData', csvData)
                    // console.log("config ", config)
                    // if (csvData.inValidMessages.length > 0) {
                    //     $("#uploadFile").val("")
                    //     this.setState({
                    //         show: true,
                    //         basicTitle: 'dont upload other fields',
                    //         basicType: 'danger'
                    //     });
                    // } else {
                    //     this.setState({
                    //        csvcontent: csvData.data
                    //     });
                    // }
                    let keys = Object.keys(csvData.data[0])
                    // let csvalues = Object.values(csvData.data[0])
                    let items = ['consignee_name','consignee_code','consignee_city','consignee_address','consignee_state','postal_code','consignee_zone','consignee_latitude','consignee_longitude','consignee_region','consignee_area_office','credit_sales','destination_type','mobile_no_1','mobile_no_2','mobile_no_3','consignee_email']
                    let check = false
                    if(csvData.inValidMessages.length === 0)
                    {
                        for (let i in keys){
                             console.log("items.includes(keys[i]) ", items.includes(keys[i]))
                            if(items.includes(keys[i])){                 
                                check = true             
                            }else{
                                check = false
                                break
                            }
                        }
                    }
                    else{
                        check = false
                    }
                    var mobMes  = 1;
                    var textMes= 1;
                    var addressMes = 1;
                    var digitMes = 1;
                    // console.log("check", check)
                            // console.log("csvalues ", csvalues)
                    // if(csvalues.length > 0)
                    // {
                    //     for(let c in csvalues)
                    //     {
                    //         // console.log("csvalues value ",csvalues[c])
                    //         // console.log("aplhanumeichypen",aplhanumeichypen.test(csvalues[c])+"  "+csvalues[c])
                    //         if(aplhanumeichypen.test(csvalues[c]) === false)
                    //         {
                    //             check = false;
                    //             break;
                    //         }
                    //     }
                    // }

                    let csvaluesarr = Object.values(csvData.data)
                     console.log("csvaluesarr", csvaluesarr)
                    if(csvaluesarr.length > 0)
                    {
                        for(var a=0;a<csvaluesarr.length; a++)
                        {
                            var csvalues = Object.values(csvaluesarr[a])

                            for(var c in csvalues)
                            {
                               
                                    if(aplhanumeichypen.test(csvalues[c]) === false)
                                    {
                                        console.log(csvalues[c],"234")
                                        check = false;
                                        break;
                                    }
                            }
                        }
                    }

                    console.log("check2", check)
                    if (check === false) {
                        $("#uploadFile").val("")
                        // document.getElementById("appednCSVData").innerHTML = ''
                        // if(parseInt(textMes) === 0 )
                        // {
                        //     this.setState({
                        //         show: true,
                        //         basicTitle: 'Invalid  Name added',
                        //         basicType: 'danger'
                        //     });
                        // }    
                        // else{
                            this.setState({
                                show: true,
                                basicTitle: 'dont upload other fields or special characters',
                                basicType: 'danger'
                            });
                        // } 
                    } else {
                        this.setState({
                            csvcontent : csvData.data
                        });
                    } 
                })
                .catch((error) => {
                    console.log("error ",error)
                    this.setState({
                      file: null,
                      errorMessage: error.message
                    });
                  })
                  

                  
            var contentList = []
    
            var out = new Promise(function (reject, resolve) {
                var reader = new FileReader();
                reader.onload = async function (e) {
                    var contents = await e.target.result;
                    // document.getElementById("appednCSVData").innerHTML = contents
                    resolve(contents);
                };
                var tt = reader.readAsText(e.target.files[0]);
            });
            // console.log(contentList);
            this.setState({
                file: e.target.files[0]
            });
            // console.log("e.target.files[0].type ", e.target.files[0]);
    
            if (e.target.files[0].type == 'text/csv' || e.target.files[0].type == 'application/vnd.ms-excel') {
                // console.log(fileData);
                // console.log(typeof(fileData))
    
            }
            else {
                e.target.value = null;
                this.setState({
                    uploadFile: '',
                    file: "",
                    show: true,
                    basicType: 'danger',
                    basicTitle: 'Please upload file having extensions .csv only.',
                });
            }
        }

    }

    uploadBulkFormHandler = e => {
        e.preventDefault()
        const { csvcontent } = this.state
        //  console.log("csvcontent", csvcontent)
        if(csvcontent.length > 0)
        // Body is the CSV array, so dept_code goes on the URL (LCV pages only)
        redirectURL.post(getDeptMenuPath("/masters/uploadCustomerMastersData", getDeptCode()), csvcontent,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("userid")
              }
          }).then(res => {
            // console.log("response", res)
            if (res.data.message === 'success') {
                document.getElementById("upform").reset()
                var invalidRows = res.data.invalid_rows || []
                // Rows not added because the dealer code already exists in the master, or appears
                // earlier in the same file - one row per dealer code.
                var skippedRows = res.data.skipped_rows || []
                var listRows = (rows, label) => rows.slice(0, 20).map(label).join(', ') + (rows.length > 20 ? ' and ' + (rows.length - 20) + ' more' : '')
                var parts = []
                if (invalidRows.length > 0) parts.push(invalidRows.length + ' row(s) skipped for an invalid value - row ' + listRows(invalidRows, r => r.row + ' (' + r.field + ')'))
                if (skippedRows.length > 0) parts.push(skippedRows.length + ' row(s) not added, dealer code already present - row ' + listRows(skippedRows, r => r.row + ' (' + r.reason + ')'))
                // Existing dealers shared into this dept (shared master); details unchanged. See DEPT_CODE_MASTER_GUIDE.md
                var hasProblems = parts.length > 0
                var linkedRows = res.data.linked_rows || []
                if (linkedRows.length > 0) parts.push(linkedRows.length + ' existing dealer(s) added to this department with their current details - row ' + listRows(linkedRows, r => r.row + ' (' + r.consignee_code + ')'))
                var title = parts.length > 0 ? 'Uploaded. ' + parts.join('. ') : 'success'
                this.setState({
                    slider: 'show-n',
                    csvcontent: [],
                    file: '',
                    show:true,
                    overly: 'show-n',
                    loadshow: 'show-n',
                    basicTitle: title,
                    basicType: hasProblems ? 'warning' : 'success',
                })
                $("#uploadFile").val("")
                // document.getElementById("appednCSVData").innerHTML = ''
            }
            setTimeout(() =>{
                this.loadData()
            }, 1000)
        })
    
    else{
        this.setState({
            overly: "show-n",
            loadshow: 'show-n',
            basicTitle: "cant insert empty data",
            basicType: "warning",
            show: true
        })
    }

}
              

    bulkUploadTptMaster = () => {
        this.setState({
            slider: 'slider-translate-40p',
            overly: "show-m",
            loadshow: 'show-n'
        })
    }
    resetUpload = () => {
        // $("#uploadFile").val("")
         document.getElementById("upform").reset()
        // this.setState({
        //     slider: 'show-n',
        //     overly: "show-n",
        //     loadshow: 'show-n'
        // })
    }

    onClickHideAll = () => {
        $("#uploadFile").val("")
        // document.getElementById("appednCSVData").innerHTML = ''
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
            slider: "",
            sliderforeditcustomer: false,
        });
    }

    closeEditCustomerSlider = () => {
        this.setState({
            sliderforeditcustomer: false,
            overly: 'show-n'
        })
    }

    updateCustomerHandler = (e) => {
        e.preventDefault()
        const editCustomer = this.state.editCustomer
        const original = this.state.editCustomerOriginal
        const EDITABLE_FIELDS = ['consignee_address', 'consignee_city', 'consignee_state', 'postal_code',
            'consignee_latitude', 'consignee_longitude', 'consignee_zone', 'consignee_region',
            'consignee_area_office', 'credit_sales', 'destination_type', 'mobile_no_1', 'mobile_no_2', 'mobile_no_3',
            'consignee_email']

        let changes = []
        EDITABLE_FIELDS.forEach(field => {
            if (editCustomer[field] !== original[field]) {
                changes.push({ field: field, oldValue: original[field], newValue: editCustomer[field] })
            }
        })

        if (changes.length === 0) {
            this.closeEditCustomerSlider()
            return
        }

        // Immediate feedback only - the backend independently trims/validates/normalizes this
        // same field regardless of what the frontend already checked.
        var emailChange = changes.find(c => c.field === 'consignee_email')
        if (emailChange && emailChange.newValue && String(emailChange.newValue).trim() !== '') {
            var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailPattern.test(String(emailChange.newValue).trim())) {
                this.setState({ show: true, basicTitle: 'Dealer Mail ID is not a valid email address.', basicType: 'danger' })
                return
            }
        }

        redirectURL.post("/masters/updateCustomerMasterRow", {
            rowId: editCustomer.id,
            changes: changes,
            email: localStorage.getItem('email'),
            firstname: localStorage.getItem('firstname'),
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("userid")
            }
        }).then(res => {
            if (res.data.status === 'success') {
                this.setState({
                    sliderforeditcustomer: false,
                    overly: 'show-n',
                    show: true,
                    basicTitle: 'Dealer updated successfully',
                    basicType: 'success'
                })
                setTimeout(() => { this.loadData() }, 1000)
            } else {
                this.setState({
                    show: true,
                    basicTitle: res.data.message || 'Update failed',
                    basicType: 'danger'
                })
            }
        }).catch(() => {
            this.setState({
                show: true,
                basicTitle: 'Failed to save the changes.',
                basicType: 'danger'
            })
        })
    }

    onCellClicked = (e) => {
        if (e.colDef.field == "edit") {
            let data = e.data
            let editCustomer = {
                id: data._id,
                consignee_code: data.consignee_code,
                consignee_name: data.consignee_name,
                consignee_address: data.consignee_address,
                consignee_city: data.consignee_city,
                consignee_state: data.consignee_state,
                postal_code: data.postal_code,
                consignee_latitude: data.consignee_latitude,
                consignee_longitude: data.consignee_longitude,
                consignee_zone: data.consignee_zone,
                consignee_region: data.consignee_region,
                consignee_area_office: data.consignee_area_office,
                credit_sales: data.credit_sales,
                destination_type: data.destination_type,
                mobile_no_1: data.mobile_no_1,
                mobile_no_2: data.mobile_no_2,
                mobile_no_3: data.mobile_no_3,
                consignee_email: data.consignee_email,
            }
            this.setState({
                sliderforeditcustomer: true,
                editCustomer: editCustomer,
                editCustomerOriginal: { ...editCustomer },
                overly: "show-m",
                loadshow: 'show-n'
            })
        }
        else if (e.colDef.field == "delete") {
            var rowId = e.data._id;
            // console.log("delete",e.data);
            var qry = {
                rowId: rowId,
                collection : 'master_customer',
                email : localStorage.getItem('email')
            }
            if (getDeptCode() != '') {
                qry.dept_code = getDeptCode()
            }
            //var confirm = confirm("Are You Sure! Do you want really delete?");
            if (window.confirm("Are You Sure! Do you want really delete?")) {
                redirectURL.post("/masters/deleteRowData", qry,{
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("userid")
                      }
                  }).then((response) => {
                    // console.log("response",response);
                    if (response.data.status == "success") {
                        this.setState({
                            basicTitle: "Deleted Successfully.",
                            basicType: "success",
                            show: true
                        })
                        //window.location.reload();
                        setTimeout(() =>{
                            this.loadData()
                        }, 1000)
                    }
                    else {
                        this.setState({
                            basicTitle: "Failed to Delete.",
                            basicType: "warning",
                            show: true
                        })
                    }
                }).catch((e) => {
                    console.log(e);
                })
            }
        }
    }

    render() {
        const { show, basicType, basicTitle, rowData, modules, defaultColDef, statusBar, slider, loadshow, overly, sliderforeditcustomer, editCustomer } = this.state
        const plantsColumnDefs = [
            {
                headerName: "Dealer Code",
                field: "consignee_code",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            },
            {
                headerName: "Dealer Name",
                field: "consignee_name",
                width: 150,
                filter: "agSetColumnFilter",
                resizable: true,
            },
            {
                headerName: "Dealer Address",
                field: "consignee_address",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            },     
            {
                headerName: "Dealer City",
                field: "consignee_city",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            },           
            {
                headerName: "Dealer State",
                field: "consignee_state",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
                // valueGetter: param => {
                //     if (!["", NaN, undefined, null].includes(param.data.customer_state)) return param.data.customer_state
                // }
            },  
            {
                headerName: "Pincode",
                field: "postal_code",
                width: 100,
                filter: "agSetColumnFilter",
                resizable: true,                
            },
            {
                headerName: "Dealer Latitude",
                field: "consignee_latitude",
                width: 100,
                filter: "agSetColumnFilter",
                resizable: true,                
            },
            {
                headerName: "Dealer Longitude",
                field: "consignee_longitude",
                width: 100,
                filter: "agSetColumnFilter",
                resizable: true,                
            },
            {
                headerName: "Dealer Zone",
                field: "consignee_zone",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            },           
            {
                headerName: "Dealer Region",
                field: "consignee_region",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            },
            {
                headerName: "Dealer Area Office",
                field: "consignee_area_office",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            },          
            {
                headerName: "Credit Sales Dealer(Yes/No)",
                field: "credit_sales",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            },
            {
                headerName: "Destination Type(ODA/Direct)",
                field: "destination_type",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            },
            {
                headerName: "Mobile No 1",
                field: "mobile_no_1",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            },
            {
                headerName: "Mobile No 2",
                field: "mobile_no_2",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            },
            {
                headerName: "Mobile No 3",
                field: "mobile_no_3",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            },
            {
                headerName: "Dealer Mail ID",
                field: "consignee_email",
                width: 180,
                filter: "agSetColumnFilter",
                resizable: true,
            },
            // {
            //     headerName: "Dealer Contact No",
            //     field: "consignee_contact_no",
            //     width: 130,
            //     filter: "agSetColumnFilter",
            //     resizable: true,
            // },  
            {
                pinned: "left",
                headerName: "",
                field: "edit",
                width: 50,
                resizable: true,
                editable: false,
                cellRenderer: params => {
                    return '<i class="icofont icofont-ui-edit"></i>';
                },
                filter: false,
            },
            {
                pinned: "left",
                headerName: "",
                field: "delete",
                width: 50,
                resizable: true,
                editable: false,
                cellRenderer: params => {
                    return '<i class="icofont icofont-ui-delete"></i>';
                },
                filter: false,
            }                 
           
        ]

        return (
            <div className="container-fluid">
                <SweetAlert
                    show={show}
                    type={basicType}
                    title={basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>
                <div className='row'>
                    <div className="card col-xl-12 col-lg-12">
                        <div className="card-header" style={{ padding: '10px' }}>
                            <h4>Dealer Master</h4>
                            <div className="row">
                                <div className="col-sm-12">
                                    <button className="float-right btn btn-warning cc-btn" onClick={this.bulkUploadTptMaster}>
                                        <i className="icofont icofont-upload-alt"></i> Bulk Upload
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="height-equal equal-height-lg" style={{ padding: '10px' }}>
                            <div className="card-body" style={{ padding: '10px' }}>
                                <div id="myGrid" style={{ height: "400px" }} className="ag-theme-balham">
                                    <AgGridReact
                                        modules={modules}
                                        columnDefs={plantsColumnDefs}
                                        defaultColDef={defaultColDef}
                                        rowData={rowData}
                                        enableCharts={false}
                                        enableRangeSelection={true}
                                        statusBar={statusBar}
                                        pagination={true}
                                        groupHeaderHeight={40}
                                        headerHeight={45}
                                        floatingFiltersHeight={50}
                                        pivotGroupHeaderHeight={30}
                                        pivotHeaderHeight={50}
                                        rowHeight={40}
                                        onGridReady={this.onGridReady}
                                        onGridState={this.onGridState}
                                        onCellClicked={this.onCellClicked}
                                    //sideBar={sideBar}
                                    // onCellDoubleClicked={this.onShowSidebarAquireComponent.bind(this)}
                                    />
                                </div>

                            </div>

                        </div>
                        <div className={"dataLoadpage " + (loadshow)}>
                        </div>
                        <div className={"dataLoadpageimg " + (loadshow)}>
                            <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
                        </div>
                        <div className={"overlay-part " + (overly)} onClick={this.onClickHideAll}></div>


                    </div>
                        {/* tpt bulk upload  */}
                        <div className={"slide-r " + (slider)} style={{ overflow: "hidden" }}>
                            <h3 className="subH">Bulk Upload Customer Data
                             <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={this.onClickHideAll} >X</span>

                            </h3>
                            <div className="slide-r-body" style={{ position: "relative" }}>
                                <div className="container-fluid">
                                    <form method="POST" id="upform" className="theme-form" onSubmit={this.uploadBulkFormHandler}>

                                        <div className="form-group mt-20p">
                                            <label className="">Upload File</label>
                                            <input type="file" name="uploadFile" id="uploadFile" onChange={this.changeTptFileHandler} className="form-control" required />
                                            <div style={{color:"#ff0000",marginTop:"10px"}}>
                                                ** Allowed Space and Special Characters are <span style={{fontWeight:"700", fontSize:"18px", fontFamily:"arial"}}>-._,&#@</span>
                                            </div>
                                        </div>
                                        {/* <div className='p-2' id="appednCSVData"></div> */}
                                        <div className="form-group">
                                            <button type="submit" className="btn btn-success cc-btn cc-btn-form"><i className="icofont icofont-check-circled"></i> Submit</button>
                                            <button type="button" onClick={this.resetUpload} className="btn btn-default cc-btn"><i className="icofont icofont-close-circled"></i> Cancel</button>
                                        </div>
                                    </form>
                                    {/* <p className='pl-3' style={{ color: 'red' }}> please format the dates in yyyy-mm-dd hh:mm:ss or dd-mm-yyyy hh:mm:ss before uploading</p> */}
                                    <div className="form-group">
                                        <a className="btn btn-primary cc-btn cc-btn-form" href={require('../../assets/json/bulk_master_customer.csv')} target="_blank"><i className="icofont icofont-download"></i> Sample Template</a>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* edit dealer */}
                        <div className={"slide-r " + (sliderforeditcustomer ? "slider-translate-40p" : "")} style={{ overflowY: "auto" }}>
                            <h3 className="subH">Edit Dealer
                             <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={this.closeEditCustomerSlider} >X</span>
                            </h3>
                            <div className="slide-r-body" style={{ position: "relative" }}>
                                <div className="container-fluid">
                                    <form className="theme-form" onSubmit={this.updateCustomerHandler}>
                                        <div className="form-group">
                                            <label>Dealer Code</label>
                                            <input type="text" className="form-control disabled-input" value={editCustomer.consignee_code || ''} disabled />
                                        </div>
                                        <div className="form-group">
                                            <label>Dealer Name</label>
                                            <input type="text" className="form-control disabled-input" value={editCustomer.consignee_name || ''} disabled />
                                        </div>
                                        <div className="form-group">
                                            <label>Dealer Address</label>
                                            <input type="text" className="form-control" value={editCustomer.consignee_address || ''}
                                                onChange={(e) => this.setState({ editCustomer: { ...editCustomer, consignee_address: e.target.value } })} />
                                        </div>
                                        <div className="form-group">
                                            <label>Dealer City</label>
                                            <input type="text" className="form-control" value={editCustomer.consignee_city || ''}
                                                onChange={(e) => this.setState({ editCustomer: { ...editCustomer, consignee_city: e.target.value } })} />
                                        </div>
                                        <div className="form-group">
                                            <label>Dealer State</label>
                                            <input type="text" className="form-control" value={editCustomer.consignee_state || ''}
                                                onChange={(e) => this.setState({ editCustomer: { ...editCustomer, consignee_state: e.target.value } })} />
                                        </div>
                                        <div className="form-group">
                                            <label>Pincode</label>
                                            <input type="text" className="form-control" value={editCustomer.postal_code || ''}
                                                onChange={(e) => this.setState({ editCustomer: { ...editCustomer, postal_code: e.target.value } })} />
                                        </div>
                                        <div className="form-group">
                                            <label>Dealer Latitude</label>
                                            <input type="text" className="form-control" value={editCustomer.consignee_latitude || ''}
                                                onChange={(e) => this.setState({ editCustomer: { ...editCustomer, consignee_latitude: e.target.value } })} />
                                        </div>
                                        <div className="form-group">
                                            <label>Dealer Longitude</label>
                                            <input type="text" className="form-control" value={editCustomer.consignee_longitude || ''}
                                                onChange={(e) => this.setState({ editCustomer: { ...editCustomer, consignee_longitude: e.target.value } })} />
                                        </div>
                                        <div className="form-group">
                                            <label>Dealer Zone</label>
                                            <input type="text" className="form-control" value={editCustomer.consignee_zone || ''}
                                                onChange={(e) => this.setState({ editCustomer: { ...editCustomer, consignee_zone: e.target.value } })} />
                                        </div>
                                        <div className="form-group">
                                            <label>Dealer Region</label>
                                            <input type="text" className="form-control" value={editCustomer.consignee_region || ''}
                                                onChange={(e) => this.setState({ editCustomer: { ...editCustomer, consignee_region: e.target.value } })} />
                                        </div>
                                        <div className="form-group">
                                            <label>Dealer Area Office</label>
                                            <input type="text" className="form-control" value={editCustomer.consignee_area_office || ''}
                                                onChange={(e) => this.setState({ editCustomer: { ...editCustomer, consignee_area_office: e.target.value } })} />
                                        </div>
                                        <div className="form-group">
                                            <label>Credit Sales Dealer(Yes/No)</label>
                                            <input type="text" className="form-control" value={editCustomer.credit_sales || ''}
                                                onChange={(e) => this.setState({ editCustomer: { ...editCustomer, credit_sales: e.target.value } })} />
                                        </div>
                                        <div className="form-group">
                                            <label>Destination Type(ODA/Direct)</label>
                                            <input type="text" className="form-control" value={editCustomer.destination_type || ''}
                                                onChange={(e) => this.setState({ editCustomer: { ...editCustomer, destination_type: e.target.value } })} />
                                        </div>
                                        <div className="form-group">
                                            <label>Mobile No 1</label>
                                            <input type="text" className="form-control" value={editCustomer.mobile_no_1 || ''}
                                                onChange={(e) => this.setState({ editCustomer: { ...editCustomer, mobile_no_1: e.target.value } })} />
                                        </div>
                                        <div className="form-group">
                                            <label>Mobile No 2</label>
                                            <input type="text" className="form-control" value={editCustomer.mobile_no_2 || ''}
                                                onChange={(e) => this.setState({ editCustomer: { ...editCustomer, mobile_no_2: e.target.value } })} />
                                        </div>
                                        <div className="form-group">
                                            <label>Mobile No 3</label>
                                            <input type="text" className="form-control" value={editCustomer.mobile_no_3 || ''}
                                                onChange={(e) => this.setState({ editCustomer: { ...editCustomer, mobile_no_3: e.target.value } })} />
                                        </div>
                                        <div className="form-group">
                                            <label>Dealer Mail ID</label>
                                            <input type="email" className="form-control" value={editCustomer.consignee_email || ''}
                                                placeholder="dealer@example.com"
                                                onChange={(e) => this.setState({ editCustomer: { ...editCustomer, consignee_email: e.target.value } })} />
                                        </div>
                                        <div className="form-group d-flex justify-content-end" style={{ gap: "10px" }}>
                                            <button type="button" className="btn btn-default cc-btn cc-btn-form" onClick={this.closeEditCustomerSlider}><i className="icofont icofont-close-circled"></i> Cancel</button>
                                            <button type="submit" className="btn btn-success cc-btn cc-btn-form"><i className="icofont icofont-save"></i> Update</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                </div>

            </div>
        )
    }
}